var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',{attrs:{"name":"submit-source-files-page-container"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('SubmitDesign',{attrs:{"models":_vm.models,"icons":_vm.icons}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }